/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import FlexField from 'ui-permit/shared-components/registration/FlexField';

const FlexFieldComponent = FlexField();

export default class FlexFieldWrapper extends React.Component {
    render() {
        return (
            <div className="rec-grid-12-12">
                <FlexFieldComponent {...this.props} />
            </div>
        );
    }
}

FlexFieldWrapper.propTypes = {
    reservation: PropTypes.object.isRequired,
    pActions: PropTypes.object.isRequired,
    permit: PropTypes.object.isRequired,
};
